export enum DeviceType {
    ALL,
    DESKTOP,
    MOBILE,
}
